import { render, staticRenderFns } from "./saveBox.vue?vue&type=template&id=bc5479aa&scoped=true"
import script from "./saveBox.vue?vue&type=script&lang=js"
export * from "./saveBox.vue?vue&type=script&lang=js"
import style0 from "./saveBox.vue?vue&type=style&index=0&id=bc5479aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5479aa",
  null
  
)

export default component.exports